import { render } from "./FreePlusSmallIcon.vue?vue&type=template&id=9b0a254c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__